import React from 'react';
import { useTranslation } from 'react-i18next';
import './LogoSpinner.css';

interface LogoSpinnerProps {
  size?: 'small' | 'medium' | 'large';
  centered?: boolean;
}

const LogoSpinner: React.FC<LogoSpinnerProps> = ({ size = 'medium', centered = false }) => {
  const { t } = useTranslation();
  const sizeClass = {
    small: 'w-8 h-8',
    medium: 'w-12 h-12',
    large: 'w-16 h-16',
  }[size];

  return (
    <div className={centered ? 'flex items-center justify-center' : ''}>
      <div className={`logo-spinner ${sizeClass}`}>
        <img
          src="/logosvg.svg"
          alt={t('Loading')}
          className="w-full h-full object-contain"
        />
      </div>
    </div>
  );
};

export default LogoSpinner;
